module.exports = __webpack_public_path__ + "static/media/img_product_mobile.7132c8c1.png";